import { render, staticRenderFns } from "./Bloco7Sintomas.vue?vue&type=template&id=26d578a4&scoped=true&"
import script from "./Bloco7Sintomas.vue?vue&type=script&lang=js&"
export * from "./Bloco7Sintomas.vue?vue&type=script&lang=js&"
import style0 from "./Bloco7Sintomas.vue?vue&type=style&index=0&id=26d578a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d578a4",
  null
  
)

export default component.exports